import { render, staticRenderFns } from "./Tache.vue?vue&type=template&id=028091c1&scoped=true&"
import script from "./Tache.vue?vue&type=script&lang=js&"
export * from "./Tache.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028091c1",
  null
  
)

export default component.exports